import React from 'react';
import ajax from '../../utils/ajax';
import dictionary from '../../utils/dictionary';
import ActivityLoader from '../Common/ActivityLoader';
import AlertError from '../Common/AlertError';
import AlertSuccess from '../Common/AlertSuccess';
import TextInput from '../Common/TextInput';
import functions from '../../utils/functions'
import ajaxConfig from '../../utils/remote/ajaxConfig';
import ajaxSticker from '../../utils/remote/ajaxSticker';

class PopEditStickerVehicle extends React.Component {

    state = {
        userId: functions.sessionGuard(),
        plateNumber:'',
        stickerId:'',
        info: '',
        loading: false
    }

    componentDidMount() {
        const record = this.props.record
        this.setState({
            plateNumber:record.vehicle.plate_number,
            stickerId:record.invoice_id
        })
    }
    

  

    onConfirm = async (event) => {
        event.preventDefault();
        const {stickerId, plateNumber}=this.state;
        if (stickerId.length > 0 && plateNumber.length>0) {
            this.setState({
                loading: true
            })

            const server_response = await ajaxSticker.correctStickerVehicle(stickerId, plateNumber);
             this.setState({
                loading: false
            })
            if(server_response.status=="OK")
            {
                this.setState({
                    info: <AlertSuccess message={server_response.details.message} />
                })
            }else{
                this.setState({
                    info: <AlertError message={server_response.details.message} />
                })
            }

           
        } else {
            this.setState({
                info: <AlertError message={dictionary._completeFields} />
            })
        }
    }




   
    render() {

        return (
            <div className="modal" id="modal-sticker-vehicle">
                <div className="modal-dialog modal-dialog-centered" role="document">


                    <div className="modal-content modal-content-demo shadow">
                        <div className="modal-header">
                            <h6 className="modal-title">Change Sticker Vehicle</h6>
                            <button aria-label="Close" className="close" data-dismiss="modal" type="button"><span aria-hidden="true">&times;</span></button>
                        </div>
                        <div className="modal-body">
                            {this.state.info}
                            <form method="post" onSubmit={this.onConfirm}>

                              <p className='mb-4'><b>Note:</b> Payments made by this sticker won't be deleted. In case there's need to delete these payments, it's then recommended to just delete the sticker and re-enter it with the correct vehicle.</p>

                              <TextInput
                                    label="Plate Number"
                                    name="Plate Number"
                                    type="text"
                                    onChange={(e) => this.setState({plateNumber:e.target.value})}
                                    value={this.state.plateNumber}
                                />
                                

                            </form>


                        </div>
                        <div className="modal-footer">
                            {!this.state.loading && <>
                                <button className="btn ripple btn-primary" type="button" onClick={this.onConfirm}>Save Changes</button>
                                <button className="btn ripple btn-secondary" type="button" data-dismiss="modal">Close</button>
                            </>}
                            {this.state.loading && <ActivityLoader />}
                        </div>
                    </div>


                </div>
            </div>
        )


    }
}

export default PopEditStickerVehicle;
